import env from 'env'
import { Api } from '..'

import { HTTP_METHOD, HTTP_STATUS_CODES, MIME_TYPE } from '../../../constants/enums'

const headers = new Headers({
  'Content-Type': MIME_TYPE.JSON
})

export class VideoPlaybackTelemetryAPI extends Api {
  origin = env.TELEMETRY_API_BASE
  version = 'v1'

  constructor(version?: string) {
    super('api')
    if (version) this.version = version
  }

  #readErrorBody(response: Response) {
    try {
      return response.json()
    } catch (error) {
      return Promise.resolve([])
    }
  }

  public async send<T>(data: T): Promise<Array<string>> {
    try {
      await this.fetch('/events', HTTP_METHOD.POST, data, { headers })
      return []
    } catch (error) {
      if (error.response.status === HTTP_STATUS_CODES.BAD_REQUEST) {
        const data = await this.#readErrorBody(error.response)

        if (data && data.errors) {
          return [...data.errors].map(event => event.id).filter(Boolean)
        }

        return []
      } else throw error
    }
  }
}
